import { render } from "./TheContainer.vue?vue&type=template&id=64d79eb9&scoped=true"
import script from "./TheContainer.vue?vue&type=script&lang=js"
export * from "./TheContainer.vue?vue&type=script&lang=js"

import "./TheContainer.vue?vue&type=style&index=0&id=64d79eb9&scoped=true&lang=css"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d79eb9"]])

export default __exports__